/**
 * Centralized Error Codes Configuration
 * This file contains error codes used throughout the application
 */

// Error Code Constants
export const ERROR_CODES = {
  // Population Master related errors
  OWNER_NULL_POPULATION_MASTER: 'ICON0006',
  BIRTH_DATE_LESS_THAN_21_YEAR: 'ICON0007',
  BIRTH_DATE_AND_BIRTH_YEAR_NULL: 'ICON0008',
  NRIC_NOT_FOUND_POPULATION_MASTER: 'ICON0010',
  BIRTH_DATE_IS_NULL: 'ICON0012',

  // Family related errors
  NRIC_IS_ABOUT_21_YEAR: 'F0004',
  F000: 'F000',

  // General errors
  LB0004: 'LB0004', // An Error Occurred
  ACCESS_NOT_GRANTED_CODE: 'LB0005', // Consent Error
  COMMON_ERROR: 'C0004',

  // User related errors
  NRIC_STARTS_MFG: 'U0008',
  DATE_OF_DEATH: 'U0010',
  NRIC_NULL_BIRTHDAY: 'U0009',

  // ICON errors
  NEHR_CES_WEB: 'ICON0003',
  ADDED_SAME_NRIC_WITH_REQUESTER: 'ICON0005',
  ICON0009: 'ICON0009',
  FAMILY_AND_FRIEND_ALREADY_ADD: 'ICON0024',
  ADDED_SAME_NRIC_LOGIN_FAMILY_AND_FRIEND: 'ICON0025',
  ADDED_SAME_NRIC: 'ICON0029',
  FAMILY_AND_FRIEND_PENDING_REQUEST: 'ICON0030',
  FAMILY_AND_FRIEND_NULL_POPULATION_MASTER: 'ICON0031',
  ICON0032: 'ICON0032',
  CHILDREN_ALREADY_ADDED: 'ICON0033',
  CHILD_NOT_RELATED_TO_PARENT: 'ICON0034',
  ADDED_SAME_NRIC_LOGIN_CHILDREN: 'ICON0035',
  ICON0036: 'ICON0036',

  // Autopay related errors
  PATIENT_NOT_FOUND_1: 'AP0702',
  PATIENT_NOT_FOUND_2: 'AP0707',
  PATIENT_NOT_FOUND_3: 'AP0708',
  MAXIMUM_CARD_LIMIT: 'AP0812',
  CARD_RETRIEVAL_FAIL: 'E8001',
  SYSTEM_ISSUE: 'AP0004',
  DEFAULT_CARD: 'AP0811',

  // Appointment Form errors
  DEDICATED_ATTENTION_REQUIRED: 'IAPPT0036',

  // HealthierSG (HSG) Localized errors
  HSG_CAPACITY_REACHED: 'HS0007',

  // CHAS (Community Health Assist Scheme) errors
  NOT_CHAS_MEMBER: 'CHAS0005',

  // NEHR (National Electronic Health Record) errors
  NEHR_CONSENT_NOT_GRANTED: 'I0012',

  // VVIP
  ACCESS_NOT_GRANTED_VVIP: 'IAR0006',

  // NEHR Access History errors
  NEHR_ACCESS_HISTORY_NOT_ACCESSED: 'IAH0001',

  // Prescription Records errors
  PRESCRIPTION_NO_RESULT_FOUND: 'IMED0001',

  // Lab Results errors
  LAB_RESULT_NO_RESULTS_FOUND: 'ILAB0001',

  // Radiology errors
  RADIOLOGY_NO_REPORT_FOUND: 'RAD0001',

  // Discharge Records errors
  DISCHARGE_NO_RESULT_FOUND: 'IDIS0001',

  // Immunisation Records errors
  IMMUNISATION_NO_ADULT_RECORD_FOUND: 'IMMU0002',

  // Patient Master errors
  NGEMR_NO_RECORD_FOUND: 'CON0002',
} as const;

// DEROM
export const ERROR_CODE_DR316 = 'DR316';
